import React from "react";
import { connect } from "react-redux";
import { RootState } from "StoreTypes";
import {
  fetchCorrespondent,
  fetchCorrespondentLoading,
  fetchInstrument,
  fetchInstrumentLoading,
  fetchInstrumentSummary,
  fetchInstrumentSummaryLoading,
  fetchSliceDetails,
  fetchSummaryDate,
  fetchTkrCusip,
  fetchInstrumentError,
} from "../../services/reports/selectors";
import {
  CorrespondentItem,
  InstrumentItem,
  Slice,
  TkrCusip,
} from "../../types";
import { Grid } from "semantic-ui-react";
import InstrumentBar from "../../components/Instrument/InstrumentBar";
import InstrumentCharts from "../../components/Instrument/InstrumentCharts";
import {
  mapCorrespondentValues,
  getInstrument,
} from "./functions/instrumentFunctions";
import Spinner from "../../components/Spinner";
import InstrumentCorrespondent from "../../components/Instrument/InstrumentCorrespondent";
import styles from "./styles.module.scss";

interface Props {
  isDetailLoading: boolean;
  isSummaryLoading: boolean;
  isCorrespondentLoading: boolean;
  instrument: InstrumentItem;
  instrumentSummary: InstrumentItem;
  sliceDetails: Slice;
  tkrCusip: TkrCusip;
  summaryDate: string;
  correspondent: CorrespondentItem;
}

const InstrumentView = ({
  isDetailLoading,
  isSummaryLoading,
  isCorrespondentLoading,
  instrument,
  instrumentSummary,
  sliceDetails,
  tkrCusip,
  summaryDate,
  correspondent,
}: Props) => {
  return (
    <div id="instrument-view" className={styles.container}>
      <Grid.Row stretched columns={"equal"}>
        <InstrumentBar
          header={"Summary"}
          instrumentArray={getInstrument(
            instrumentSummary,
            "latest",
            summaryDate
          )}
          tkrCusip={tkrCusip}
          isLoading={isSummaryLoading}
        />
      </Grid.Row>
      <Grid.Row>
        <Spinner loading={isDetailLoading}>
          {Object.keys(instrument).length > 0 && (
            <InstrumentCharts
              instrument={instrument}
              sliceDetails={sliceDetails}
              tkrCusip={tkrCusip}
            />
          )}
        </Spinner>
      </Grid.Row>
      <Grid.Row>
        <InstrumentBar
          header={"Detail"}
          instrumentArray={getInstrument(
            instrument,
            sliceDetails.id,
            sliceDetails.date
          )}
          tkrCusip={tkrCusip}
          isLoading={isDetailLoading}
        />
      </Grid.Row>
      <Grid.Row>
        <InstrumentCorrespondent
          correspondents={mapCorrespondentValues(correspondent)}
          isLoading={isCorrespondentLoading}
          csvPath={`instrument-${tkrCusip.tkr}-${sliceDetails.date}-${sliceDetails.id}-correspondent.csv`}
        />
      </Grid.Row>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isDetailLoading: fetchInstrumentLoading(state),
  isSummaryLoading: fetchInstrumentSummaryLoading(state),
  isCorrespondentLoading: fetchCorrespondentLoading(state),
  instrument: fetchInstrument(state),
  instrumentSummary: fetchInstrumentSummary(state),
  sliceDetails: fetchSliceDetails(state),
  tkrCusip: fetchTkrCusip(state),
  error: fetchInstrumentError(state),
  summaryDate: fetchSummaryDate(state),
  correspondent: fetchCorrespondent(state),
});
export default connect(mapStateToProps)(InstrumentView);
